import { Section, Image, Title, WysiwygText } from "components/shared"

const MoreInfo = ({ title, description, image }) => {
  return (
    <Section id="treatment" className="bg-blue text-white antialiased" contentClassName="flex flex-col space-y-12" animate>
      {/* <div className="text-center space-y-4">
        <Title title={title} pretitle="Treatment" size="sm" center width="max" animate />
        {subtitle && (
          <motion.div className="text-xl font-medium text-white/80" {...itemAnimation()}>
            {subtitle}
          </motion.div>
        )}
      </div> */}
      <div className="flex flex-col-reverse lg:flex-row gap-16 lg:gap-24">
        <div className="lg:flex-3 flex justify-center">
          <Image image={image} className="flex-1 max-w-[460px] w-[460px] lg:w-full h-[540px]" animate />
        </div>
        <div className="lg:flex-4 space-y-8">
          <Title title={title} pretitle="Treatment" size="sm" width="max" animate />
          <WysiwygText text={description} animate />
        </div>
      </div>
    </Section>
  )
}

export default MoreInfo
